import React from 'react';
import moment from 'moment';
import formatFileSize from 'utils/formatFileSize';
import Table, {THead, TBody, Tr, Td, Th } from 'components/UIKit/Table';
import DownloadIcon from 'components/icons/DownloadIcon';
import DownloadContainer from 'containers/DownloadContainer';
import { ErrorReportContainer, ValidReportContainer } from 'containers/SubmissionReports';

let TransactionDocuments = ({ tx }) => {
  if (!tx.documents.length) return <div>No documents in this transaction.</div>;

  return (
    <Table customDataTestID="table-transaction-documents" style={{ border: '1px solid #e5e5e5' }}>
      <THead>
        <Tr>
          {tx.type === 'delete'
            ? <Th>ID</Th>
            : <Th>Filename</Th>
          }
          {tx.type !== 'delete' &&
            <Th style={{ textAlign: 'right', width: '3rem' }}>Size</Th>
          }
          <Th>Report</Th>
        </Tr>
      </THead>
      <TBody>
        {tx.documents.map(doc =>
          <Tr key={doc.id || doc.name}>
            <Td>
              {tx.type === 'delete' && doc.id}
              {tx.type !== 'delete' &&
                <DownloadContainer
                  customDataTestID="button-download-transaction-document-file"
                  body={doc.doc}
                  format={doc.doc_format}
                  filename={doc.name || `${doc.id}.${doc.doc_format}`}
                >
                  <span style={{cursor: 'pointer', color: 'rgb(0, 45, 119)'}}>
                    {doc.name || `${doc.id}.${doc.doc_format}` }
                  </span>
                </DownloadContainer>
              }
            </Td>
            {tx.type !== 'delete' &&
              <Td style={{textAlign: 'right', whiteSpace: 'nowrap'}}>
                {formatFileSize(doc.doc_size) || '...'}
              </Td>
            }
            <Td>
              {(doc?.response?.entities || []).reduce((acc, e) => [...acc, ...e.errors], []).length > 0 &&
                <ErrorReportContainer
                  customDataTestID="button-download-transaction-document-report"
                  filename={`${doc.name || doc.id}_error_report_${moment(tx.created_datetime).format('YYYYMMDDHHmm')}.tsv`}
                  entities={ (doc?.response || {})?.entities }
                >
                  <a
                    style={{
                      color: `rgb(187, 14, 61)`,
                      cursor: `pointer`
                    }}
                  >
                    <DownloadIcon /> Error Report
                  </a>
                </ErrorReportContainer>
              }
              {(doc?.response?.entities || []).length === 0 &&
                <DownloadContainer
                  customDataTestID="button-download-transaction-document-report"
                  body={doc?.response?.message}
                  format="TSV"
                  filename={`${doc.name || doc.id}_error_report_${moment(tx.created_datetime).format('YYYYMMDDHHmm')}.tsv`}
                >
                  <a
                    style={{
                      color: `rgb(187, 14, 61)`,
                      cursor: `pointer`
                    }}
                  >
                    <DownloadIcon /> Error Report
                  </a>
                </DownloadContainer>
              }
              {tx.type !== 'delete' && (doc?.response?.entities || []).length !== 0 &&
                (doc?.response?.entities || []).reduce((acc, e) => [...acc, ...e.errors], []).length === 0 &&
                <ValidReportContainer
                  customDataTestID="button-download-transaction-document-report"
                  entities={ doc?.response?.entities }
                  filename={`${doc.name || doc.id}_${tx.type}_report_${moment(tx.created_datetime).format('YYYYMMDDHHmm')}.tsv`}
                >
                  <a
                    style={{
                      color: '#007100',
                      cursor: 'pointer',
                    }}
                  >
                    <DownloadIcon /> Report
                  </a>
                </ValidReportContainer>
              }
            </Td>
          </Tr>
        )}
      </TBody>
    </Table>
  );
};

export default TransactionDocuments;
